import { Component, OnInit, OnDestroy } from '@angular/core';
import { PagingController } from '../../../shared/commons/paging-controller/paging-controller';
import { ActivatedRoute, Router } from '@angular/router';
import { HelpersService } from '../../../core/helpers/helpers.service';
import { BasePageComponent } from '../../commons/base-page/base-page.component';
import { VodDataRestService } from '../../../data/vod/vod-data-rest.service';
import { ContentExtended } from '../../../data/vod/models/contentExtended';
import { DeviceDetectorService } from 'ngx-device-detector';
import { Location } from '@angular/common';
import { DataSharingService } from '../../../core/data-sharing/data-sharing.service';
import { ContentListResponse } from '../../../data/cms-vod-client-api/model/contentListResponses';

@Component({
  selector: 'app-content-search',
  templateUrl: './content-search.component.html',
  styleUrls: ['./content-search.component.css'],
  // templateUrl: '../content-grid/content-grid.component.html',
  // styleUrls: ['../content-grid/content-grid.component.css'],
  providers: [PagingController]
})
export class ContentSearchComponent extends BasePageComponent implements OnInit, OnDestroy {
  public title: string;
  public movies: Array<ContentListResponse>;
  public searchQuery: string | null;
  public searchType: string | null;
  posterUpcomings: string[] = [];
  isMobile: boolean;
  isDesktop: boolean;
  noResultFound: boolean;

  constructor(helpers: HelpersService,
    private router: Router,
    private dataSource: VodDataRestService,
    private route: ActivatedRoute,
    public paging: PagingController,
    private deviceService: DeviceDetectorService,
    private location: Location,
    private dataSharing: DataSharingService
  ) {
    super(helpers);
    this.isMobile = deviceService.isMobile();
    this.isDesktop = deviceService.isDesktop();

    // route.params.subscribe(val => {
    //   this.parseParams();
    // });
    // route.queryParams.subscribe(val => {
    //   this.parseParams();
    // });
    if (!this.isMobile) {
      if (this.route.snapshot.paramMap.get('query').length > 2) {
        this.getContents()
      }

      paging.pageChanged.subscribe(() => {
        this.getContents();
      });
    }
    else {
      let mobileSearch = document.getElementById('mobile-search');
      // mobileSearch.focus();
    }

  }

  ngOnInit() {
    // if (!this.isMobile) {
    //   this.paging.init(0, 0, 15);
    // }
  }

  getContents() {
    // this.searchType = this.route.snapshot.paramMap.get('type');
    if (!this.isMobile) {
      this.searchQuery = this.route.snapshot.paramMap.get('query');
    }
    this.title = `'${this.searchQuery}' için arama sonuçları`;

    // this.dataSource.searchContents(this.searchType, this.searchQuery).subscribe(data => {
    if (this.searchQuery != '') {
      this.dataSource.searchContents(this.searchQuery).subscribe(data => {
        // this.paging.total = Math.ceil(data.length / this.paging.pageSize);
        // this.paging.current = Math.max(0, Math.min(this.paging.current, this.paging.total - 1));
        // if (!this.isMobile) {
        //   // this.paging.update(data.length);
        //   // this.movies = data.slice(this.paging.current * this.paging.pageSize, (this.paging.current + 1) * this.paging.pageSize);
        //   this.movies = data;
        // }
        // else {
        //   this.movies = data;
        // }
        this.movies = data;
        if (this.movies.length == 0) {
          this.title = `'${this.searchQuery}' için sonuç bulunamadı :(`
        }
      
      });
    }
  }


  // private parseParams() {
  //   this.searchType = this.route.snapshot.paramMap.get('type');
  //   this.searchQuery = this.route.snapshot.paramMap.get('query');
  //   this.paging.current = Math.max(0, parseInt(this.route.snapshot.queryParamMap.get('page') || '0', 10));
  //   this.getContent();
  // }

  /*

  public getUrl(movie: MovieItem): string {
    return [
      window.location.protocol, '//',
      window.location.hostname,
      !(window.location.port === '80' || window.location.port === '443') ? ':' + window.location.port : '',
      this.router.createUrlTree(['/contentDetail', movie.external_id]).toString()
    ].join('');
  }
*/

  ngOnDestroy() {
    if (this.searchQuery) {
      this.dataSharing.clearSearch(true)
    }
  }

}




// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/sportstv/client/sportstv-web-client-prod/src/app/views/vod/content-search/content-search.component.ts